module.exports = __webpack_public_path__ + "img/tjtb_2.c556f8dd.png";